<template>
    <div class="wrapper">
        <app-header></app-header>
        <!-- preloader -->
        <div class="preloader" v-if="isLoading">
            <div class="spinner spinner-1"></div>
        </div>
        <!-- /preloader -->
        <router-view></router-view>
        <app-footer></app-footer>
    </div>
</template>

<script>
/*eslint-disable */
import { initAuthListener } from '@/utils/authChannel';

import footer from '@/components/footer/index.vue';
import header from '@/components/header/index.vue';

export default {
    name: 'app',
    components: {
        'app-header': header,
        'app-footer': footer,
    },
    props: [],
    computed: {
        isLoading() {
            return this.$store.state.loader.loading || false
        }
    },
    mounted() {
        // Starts listening for the logout signal from other tabs right when the app loads
        initAuthListener();
    }
}

</script>

<style lang="scss">@import url('https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700;800&display=swap');
@import url("https://fonts.googleapis.com/css?family=Lato:100,100i,300,300i,400,400i,700,700i,900,900i");
@import url("../assets/css/video.scss");
@import url("../assets/font-awesome/css/font-awesome.min.css");
@import url("../assets/fonts/AlienAndroid/styles.css");
@import url("../assets/fonts/blogHeading/stylesheet.css");
@import url("../assets/fonts/georgia/stylesheet.css");

@font-face {
  font-family: 'BeonMedium';
  src: url("../assets/fonts/beon/beon-webfont.eot");
  src: url("../assets/fonts/beon/beon-webfont.eot?#iefix") format("embedded-opentype"), url("../assets/fonts/beon/beon-webfont.woff") format("woff"), url("../assets/fonts/beon/beon-webfont.ttf") format("truetype"), url("../assets/fonts/beon/beon-webfont.svg#BeonMedium") format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'AceSansDemo';
  src: url("../assets/fonts/AceSansDemo/AceSansDemo.eot");
  src: url("../assets/fonts/AceSansDemo/AceSansDemo.eot?#iefix") format("embedded-opentype"), url("../assets/fonts/AceSansDemo/AceSansDemo.woff") format("woff"), url("../assets/fonts/AceSansDemo/AceSansDemo.ttf") format("truetype"), url("../assets/fonts/AceSansDemo/AceSansDemo.svg#AceSansDemo") format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'LiberationSans';
  src: url("../assets/fonts/LiberationSans/LiberationSans.eot?#iefix") format("embedded-opentype"), url("../assets/fonts/LiberationSans/LiberationSans.woff") format("woff"), url("../assets/fonts/LiberationSans/LiberationSans.ttf") format("truetype"), url("../assets/fonts/LiberationSans/LiberationSans.svg#LiberationSans") format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'binchrt';
  src: url("../assets/fonts/binchrt.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  src: url("../assets/fonts/sylfaen/Sylfaen.eot?#iefix") format("embedded-opentype"), url("../assets/fonts/sylfaen/Sylfaen.woff") format("woff"), url("../assets/fonts/sylfaen/Sylfaen.ttf") format("truetype"), url("../assets/fonts/sylfaen/Sylfaen.svg#Sylfaen") format("svg");
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'BeonMedium', sans-serif !important;
  font-size: 14px !important;
  color: #9b9b9b !important;
  line-height: 1.3 !important;
  background: #000000 !important;
  margin: 0px !important;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

ul.login_btn {
  margin-bottom: 0px;
}

a,
a:hover {
  text-decoration: none;
}

.font_large {
  font-size: 70px;
  line-height: 45px;
}

.header_fix {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}

.header_fix .navbar {
  padding: 10px 15px;
}

.navbar-brand .img-fluid {
  max-width: 270px;
}

.navbar-brand {
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease-in;
  transform-origin: left center;
  -webkit-transform-origin: left center;
  transform: scale(1);
  -webkit-transform: scale(1);
}

.msg_link,
.msg_link_chat {
  color: #000000 !important;
  text-decoration: none !important;
  word-break: break-word;
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.2;
}

.login_btn li .btn-default.planet_img img {
  width: 37px;
}

.login_btn li {
  display: inline-block;
  vertical-align: middle;
  margin-right: 21px;
}

.login_btn li:last-child {
  margin-right: 0px;
}

.login_btn li .btn-default {
  line-height: 34px;
  background: rgba(255, 255, 255, 0.07);
  color: #ffffff;
  font-size: 16px;
  padding: 0px 20px;
  transition: all ease 0.5s;
  -webkit-transition: all ease 0.5s;
  -moz-transition: all ease 0.5s;
  box-shadow: none;
  outline: 0px;
  min-width: 115px;
  font-weight: normal;
}

.login_btn li .btn-default.Q_btn {
  font-size: 30px;
}

.login_btn li .btn-default .img-fluid {
  width: 45px;
}

.hover_img {
  display: none;
}

.login_btn li .btn-default:hover .hover_img {
  display: inline-block;
}

.login_btn li .btn-default:hover .normal_img {
  display: none;
}

.login_btn li .btn-default:hover {
  background: #87cefa;
  color: #000000;
  font-weight: bold;
}

.section {
  height: 100dvh;
  background-size: cover;
  background-position: top center;
  position: relative;
  background-repeat: no-repeat;
}

.home_welcome {
  background-color: #000;
  background-size: 100% 100%;
  overflow: hidden;
}

.welcome_popup {
  position: relative;
  right: -120%;
  transition: all ease 0.7s;
}

.welcome_popup.active {
  right: 0;
}

.home_welcome .container {
  padding-top: 67px;
  max-width: 98%;
}

.section .container {
  display: table;
  width: 100%;
  height: 100%;
}

.center_content {
  display: table-cell;
  vertical-align: middle;
}

.light_bg_section {
  background: rgba(0, 0, 0, 0.7);
  padding: 0px;
}

.section_heading {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  color: #fff;
  line-height: 1.5;
  font-weight: normal;
  text-align: left;
  font-size: 25px;

  @media only screen and (max-width:767px) {
    font-size: 18px;
  }
}

.section_heading span {
  font-family: 'BeonMedium', sans-serif;
  font-size: 34px;
  color: #ffc107;
}

.lymphomap_about .section_heading span,
.welcome_popup_wrp .section_heading span {
  color: #d29e00;
}

.section_heading span.popup_main_title_lymphomap {
  color: #87cefa;
  font-size: 26px;
}

.welcome_popup .light_bg_section {
  height: calc(100dvh - 115px);
}

.welcome_popup_wrp .section_heading {
  font-size: 30px;
  text-align: justify;
  color: #d6d6d6;
}

.welcome_popup .section_heading {
  max-width: 1240px;
  margin: 0 auto 12px;
}

.welcome_section {
  padding: 10px;
  text-align: left;
  background: #000;
  min-height: 100dvh;
  position: relative;
  overflow: hidden;
}

.welcome_top_layers .img-fluid,
.welcome_btm_layers .img-fluid {
  max-width: 70%;
  height: 100%;
}

.welcome_btm_layers {
  text-align: right;
  margin-top: 15px;
  padding-right: 20px;
}

.welcome_logo .img-fluid {
  max-width: 580px;
  transition: all .8s ease;
  -webkit-transition: all .8s ease;
  transform: scale(1);
  -webkit-transform: scale(1);
  transform-origin: center center;
  -webkit-transform-origin: center center;
}

.welcome_logo_text:hover+.welcome_logo .img-fluid {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
}

.welcome_logo {
  display: block;
  text-align: center;
}

.welcome_logo_btm_text .img-fluid {
  max-width: 455px;
}

.welcome_top_layers {
  padding-left: 20px;
}

.welcome_logo_btm_text {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
}

.welcome_center_layers {
  position: relative;
  top: -30px;
  margin-bottom: -30px;
  height: 160px;
  opacity: 1;
}

.welcome_logo_inner {
  display: inline-block;
  position: relative;
}

.welcome_logo_wrp {
  text-align: center;
}

.welcome_logo_text {
  max-width: 439px;
  height: 70px;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 10px;
  cursor: pointer;
  z-index: 100;
}

.header_show .header_fix {
  opacity: 1;
  visibility: visible;
}

.learn_more_btn {
  display: inline-block;
  background: #640000;
  text-decoration: none;
  font-size: 16px;
  text-align: center;
  padding: 8px 30px;
  font-family: Arial, Helvetica, sans-serif;
  text-transform: uppercase;
  color: #fff;
  transition: all ease 0.5s;
  -webkit-transition: all ease 0.5s;
  -moz-transition: all ease 0.5s;
}

.learn_more_btn:hover {
  background: #ffffff;
  color: #000000;
}

.l_btn_wrp {
  text-align: center;
  padding-top: 50px;
}

.footer_wrp {
  background: #171717;
  text-align: center;
  padding: 10px 0;
  font-family: 'Lato', sans-serif;
  position: relative;
  z-index: 1000;
}

.footer_nav li {
  display: inline-block;
  vertical-align: middle;
  color: #ffffff;
  font-size: 16px;
}

.footer_nav li a {
  color: #ffffff;
  font-size: 15px;
  font-weight: 400;
  transition: all 0.2s cubic-bezier(0, 0, 0.58, 1);
  -webkit-transition: all 0.2s cubic-bezier(0, 0, 0.58, 1);
  -moz-transition: all 0.2s cubic-bezier(0, 0, 0.58, 1);
}

.footer_nav li a:hover {
  font-weight: bold;
}

.footer-copy {
  color: #ffffff;
  font-size: 15px;
  font-weight: 400;
  margin-top: 5px;
}

.preloader {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fefefe;
  z-index: 100000;
}

.loader {
  width: 120px;
  height: 120px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -60px 0 0 -60px;
  font-size: 10px;
  text-indent: -12345px;
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #333;
  border-left: 1px solid #333;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-animation: spinner 500ms infinite linear;
  -moz-animation: spinner 500ms infinite linear;
  -ms-animation: spinner 500ms infinite linear;
  -o-animation: spinner 500ms infinite linear;
  animation: spinner 500ms infinite linear;
  z-index: 100001;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.welcome_top_layers,
.welcome_btm_layers {
  height: calc(50vh - 80px);
}

.welcome_logo_btm_text_inner {
  position: relative;
  min-width: 480px;
  display: inline-block;
}

.white_cursor {
  width: 20px;
  position: absolute;
  right: -75px;
  top: 100%;
}

.typewrite {
  color: #008000;
  font-family: 'binchrt';
  text-transform: uppercase;
  font-size: 26px;
  margin: 0;
  line-height: 22px;
}

.typewrite .wrap {
  line-height: 12px;
  display: inline-block;
  vertical-align: middle;
  margin: auto;
  min-height: 16px;
  word-spacing: -10px;
  letter-spacing: 1px;
}

.ab_main_popup {
  position: absolute;
  top: 0;
  right: -220%;
  display: flex;
  height: 100dvh;
  padding-top: 62px;
  transition: all ease 0.7s;
  -webkit-transition: all ease 0.7s;
  width: 100%;
  z-index: 10001;
}

.active_popup .welcome_center_layers {
  opacity: 0;
}

.ab_main_popup.active {
  right: 0px;
}

.ab_main_popup .light_bg_popup {
  background: rgba(0, 0, 0, 0.9);
  padding: 15px 25px;
  height: calc(100dvh - 160px);
  display: flex;
  align-items: center;
  max-width: 1080px;
  margin: auto;
  position: relative;
  z-index: 10000;
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.045);
}

.lymphomap_computer_data.ab_main_popup .light_bg_popup {
  height: calc(100dvh - 80px);
  max-width: 1000px;
}

.wrapper {
  overflow: hidden;
  position: relative;
}

@media only screen and (max-width: 1350px) {
  .login_btn li .btn-default {
    font-size: 14px;
    padding: 3px 15px;
  }

  .login_btn li .btn-default .img-fluid {
    width: 38px;
  }

  .login_btn li .btn-default.planet_img img {
    width: 30px;
  }
}

@media screen and (max-width: 768px) {
  .spinner {
    width: 80px;
    height: 80px;
  }
}

@media screen and (max-width: 738px) {
  .spinner {
    width: 70px;
    height: 70px;
  }
}

@media screen and (max-width: 414px) {
  .spinner {
    width: 60px;
    height: 60px;
  }
}

.fixloader {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.72);
  width: 100%;
  z-index: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  position: relative;
  width: 125px;
  height: 125px;
  margin: 30px auto;
}

.spinner:before,
.spinner:after {
  content: "";
  display: block;
  position: absolute;
  border-width: 4px;
  border-style: solid;
  border-radius: 50%;
}

@-webkit-keyframes rotate-animation {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotate-animation {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes anti-rotate-animation {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}

@keyframes anti-rotate-animation {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}

.spinner.spinner-1:before {
  width: 117px;
  height: 117px;
  top: 0px;
  left: 0px;
  -webkit-animation: rotate-animation 1s linear 0s infinite;
  animation: rotate-animation 1s linear 0s infinite;
}

.spinner.spinner-1:after {
  width: 81.9px;
  height: 81.9px;
  top: 17.55px;
  left: 17.55px;
  -webkit-animation: anti-rotate-animation 0.85s linear 0s infinite;
  animation: anti-rotate-animation 0.85s linear 0s infinite;
}

.spinner.spinner-1:before {
  border-bottom-color: #3498db;
  border-right-color: #3498db;
  border-top-color: rgba(255, 0, 0, 0);
  border-left-color: rgba(255, 0, 0, 0);
}

.spinner.spinner-1:after {
  border-bottom-color: #e74c3c;
  border-right-color: #e74c3c;
  border-top-color: rgba(255, 0, 0, 0);
  border-left-color: rgba(255, 0, 0, 0);
}

.login_body .header_fix {
  background: none;
  width: calc(100% - 65px);
}

.profile-dob .mx-datepicker {
  display: block;
  width: 180px;
}

.profile-dob .mx-calendar-icon {
  color: #ffffff;
}

.profile-dob .mx-input-icon {
  color: #ffffff;
}

.profile-dob .mx-input {
  padding: .375rem .75rem;
  background: rgba(201, 219, 220, 0.5) !important;
  border-color: transparent;
  font-size: 15px;
  color: #ffffff;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  -webkit-transition: all cubic-bezier(0.42, 1.14, 1, 1) 0.7s;
  transition: all cubic-bezier(0.42, 1.14, 1, 1) 0.7s;
  height: 38px;
  border-radius: .25rem;
  border: none;
}

.profile-dob .mx-icon-calendar,
.profile-dob .mx-icon-clear {
  color: #ffffff !important;
}

.profile-dob .mx-input:focus {
  color: #ffffff;
  background-color: #fff;
  border: none;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.profile-dob .mx-input:focus~.mx-calendar-icon,
.profile-dob .mx-input:focus~.mx-input-icon {
  color: #000000;
}

body.task_modal_actv {
  overflow: hidden;
}

body.dashboard::after {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/images/lymphomap-landing-blank.jpg") 50% fixed #222423;
  background-size: cover;
  background-repeat: no-repeat;
}

body.dashboard::before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/images/slide_img.png") fixed;
  background-repeat: no-repeat;
  z-index: 2;
  background-size: 77.6%;
  right: 0;
  background-position: center center;
  opacity: .6;
}

body.dashboard .wrapper {
  z-index: 10;
}

body .back_btn {
  border-radius: 35px;
  padding: 0;
  margin-right: 10px;
  font-size: 16px;
  display: inline-block;
  vertical-align: text-bottom;
  line-height: 32px;
  width: 32px;
  height: 32px;
  outline: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

body .back_btn:hover {
  background: #87cefa;
  color: #000000;
}

select.form-control {
  -moz-appearance: none;
}

.Messages_list .sent {
  text-align: right;
}

.Messages_list .sent span {
  background: #b1d4e5;
  display: inline-block;
  padding: 5px 10px;
  line-height: 1.3;
  border-radius: 5px 0px 5px 5px;
  max-width: 90%;
  text-align: left;
  word-break: break-all;
  white-space: normal;
  position: relative;
  font-size: 13px;
  font-weight: 500;
}

.Messages_list .recieved span {
  background: #ffb6c1;
  display: inline-block;
  padding: 5px 10px;
  line-height: 1.3;
  border-radius: 0px 5px 5px 5px;
  max-width: 90%;
  text-align: left;
  word-break: break-all;
  white-space: normal;
  position: relative;
  font-size: 13px;
  font-weight: 500;
}

.Messages_list li {
  font-size: 13px;
  margin-bottom: 8px;
}

.Messages_list li:last-child {
  margin-bottom: 0px;
}

.chat_user_content {
  display: none;
}

.chat_user_content.show {
  display: block;
}

.select_user_content .chat_user_content {
  display: block !important;
}

#frame .content .messages li {
  clear: both;
  float: left;
  margin: 5px 0px;
  width: 100%;
  font-size: 13px;
}

#frame .content .messages li.sent img,
#frame .content .messages li.sent_list img {
  margin: 6px 8px 0 0;
}

#frame .content .messages .sent .chat_in_msg_box_wrp,
#frame .content .messages .sent_list .chat_in_msg_box_wrp {
  background: linear-gradient(180deg, #d0efff, #a0e0ff);
  color: #000000;
  border-radius: 0px 7px 7px 7px;
  text-align: left;
}

#frame .content .messages .recieved,
#frame .content .messages .recieved_list {
  text-align: right;
}

#frame .content .messages .recieved .chat_in_msg_box_wrp,
#frame .content .messages .recieved_list .chat_in_msg_box_wrp {
  background: linear-gradient(180deg, #ffe7eb, #ffa2b0);
  color: #000;
  border-radius: 7px 0px 7px 7px;
  text-align: left;
}

#frame .content .messages li .chat_in_msg_box_wrp {
  display: inline-block;
  padding: 5px 8px;
  line-height: 130%;
  margin: 0;
  max-width: calc(100% - 60px);
  word-break: break-word;
  white-space: normal;
  width: auto;
  position: relative;
  font-weight: 500;
}

.chat_tabs.active {
  background: #87cefa !important;
  color: #000 !important;
}

.chat_tabs.active span {
  color: inherit !important;
}

body.showoverlay {
  overflow: hidden;
}

body.showoverlay .modal {
  position: fixed;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  padding: 30px 15px 30px;
  overflow: auto !important;
  height: 100dvh;
  display: none;
}

body.showoverlay .modal.show {
  display: flex;
  display: -webkit-flex;
}

body.showoverlay .modal .modalbox {
  width: 100%;
  background: #000000;
  border-radius: 10px;
  display: block;
  position: relative;
  height: auto;
  color: #ffffff;
  font-size: 15px;
  box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
  -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
}

body.showoverlay .modal .modalbox .modal-header {
  position: relative;
  font-size: 22px;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  padding: 15px 45px 15px 17px;
  color: #ffffff;
  text-transform: none;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  font-weight: 500;
}

body.showoverlay .modal .modalbox .modal-header .btn-close {
  background: none;
  border: none;
  width: 28px;
  position: absolute;
  right: 10px;
  top: 14px;
}

body.showoverlay .modal .modalbox .modal-header .btn-close .fa {
  font-size: 20px;
  color: red;
}

body.showoverlay .modal .modalbox .modal-header .btn-close:focus {
  outline: none;
  box-shadow: none;
}

body.showoverlay .modal .modalbox .modal-body {
  padding: 30px;
}

body.showoverlay .modal .modalbox .modal-body h1,
body.showoverlay .modal .modalbox .modal-body h2,
body.showoverlay .modal .modalbox .modal-body h3,
body.showoverlay .modal .modalbox .modal-body h4,
body.showoverlay .modal .modalbox .modal-body h5,
body.showoverlay .modal .modalbox .modal-body h6 {
  color: #222423;
  letter-spacing: 0.02em;
}

body.showoverlay .modal .modalbox .modal-body .form-control {
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
}

.covid_19_popup.popup_actv {
  height: 100dvh !important;
  width: 100vw !important;
  left: 0 !important;
  bottom: 0 !important;
  padding: 12px !important;
  border-width: 4px !important;
}

.covid_19_popup.popup_actv .covid_19_popup_expand_btn {
  display: block !important;
}

.covid_19_popup_actv .lymphomap_auth_main {
  opacity: 0;
}

.covid_19_popup_actv header.header_fix {
  opacity: 0;
  display: none;
}

.covid_19_popup_actv {
  overflow: hidden;
}

.covid_19_popup_actv .covid_19_popup .covid_19_popup_inner .covid_19_popup_center_conten {
  vertical-align: top !important;
}

.covid_19_popup_actv .covid_19_popup .covid_19_popup_inner {
  padding: 15px !important;
}

.chart_wrp .chartjs-render-monitor {
  height: calc(100dvh - 330px) !important;
}

.graph_wrp {
  height: calc(100dvh - 285px) !important;
  overflow: hidden;
}

.chart_graph_popup .MJXc-display,
.data_search_form .MJXc-display {
  display: inline-block;
  outline: none;
  cursor: none;
  margin: 0;
}

.syntax_highlighter_wrp pre code {
  width: 100%;
  border: 1px solid grey;
  height: 380px;
  font-size: 14px;
}

.chat_menuburger_wrp.active .chat_menuburger>span {
  background: gold !important;
}

.covid_popup_disabled.covid_19_popup,
.covid_popup_disabled .covid_19_popup,
.popup_actv .covid_19_popup {
  opacity: 0.09;
}

.covid_popup_disabled .more_info_add {
  display: none;
}

#frame .content .messages .msg_in_file {
  padding: 0;
  background: none;
  border-radius: 0;
  max-width: 100%;
  display: table;
  height: 100%;
  margin-bottom: 0px;
  float: none;
  width: 100%;
  text-align: center;
  margin: 0 auto;
}

.task_accordion_wrp.actv_accordion .task_accordion_body {
  display: block;
}

.lymphomap_about.ab_main_popup .light_bg_popup,
.welcome_popup_wrp.ab_main_popup .light_bg_popup {
  height: calc(100dvh - 80px);
  overflow-y: auto;
  max-width: 1000px;
  display: block;
  width: 100%;
}

.lymphomap_about.ab_main_popup .light_bg_popup::-webkit-scrollbar,
.welcome_popup_wrp.ab_main_popup .light_bg_popup::-webkit-scrollbar {
  width: 0px;
  background: transparent;
  border-radius: 2px;
}

.lymphomap_about.ab_main_popup .light_bg_popup::-webkit-scrollbar-thumb,
.welcome_popup_wrp.ab_main_popup .light_bg_popup::-webkit-scrollbar-thumb {
  background-color: #000;
}

.lymphomap_about.ab_main_popup .light_bg_popup .welcome_popup_inner,
.welcome_popup_wrp.ab_main_popup .light_bg_popup .welcome_popup_inner {
  display: table;
  height: calc(100dvh - 110px);
  width: 100%;
}

.lymphomap_about.ab_main_popup .light_bg_popup .welcome_popup_inner .ab_content_center,
.welcome_popup_wrp.ab_main_popup .light_bg_popup .welcome_popup_inner .ab_content_center {
  display: table-cell;
  vertical-align: middle;
}

.actv_accordion .task_accordion_desc {
  display: none !important;
}

.actv_accordion .task_accordion_header .task_accordion_arrow {
  z-index: 99 !important;
}

.dashboard.mobileNoupdatePopup {
  overflow-y: hidden;
}

.workspace_main_page_wrp #Smallchat {
  display: none !important;
}

@media only screen and (max-width: 767px) {
  .mbl_none {
    display: none !important;
  }
}

@media only screen and (min-width: 767px) {
  .desktop_none {
    display: none !important;
  }
}

@media only screen and (min-width: 1023px) {
  .only_desktop_none {
    display: none !important;
  }
}

@media only screen and (max-width: 1023px) {
  .ipad_none {
    display: none !important;
  }
}

body.videoNotificationPopup {
  overflow-y: hidden;
}

.hyper_link {
  color: #18027e !important;
  font-size: 15px;
  line-height: 1.2;
  text-decoration: none !important;
}

.vue-tel-input.custom_mobile_number {
  position: relative;
}

.vue-tel-input.custom_mobile_number .invalid-feedback {
  display: block;
  position: absolute;
  bottom: -23px;
  font-size: 13px;
  font-weight: 600;
}

.no_contact_found_txt {
  text-align: center;
  padding-top: 50px;
  font-size: 20px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
  color: rgba(255, 255, 255, 0.8);
}

.video_dashboard_wrp .video_toolbar_with_prfl_img.video_toolbar_for_self>.container {
  max-width: 360px !important;
}

.video_dashboard_wrp .video_toolbar_with_prfl_img.video_toolbar_for_self .video_toolbar_list li .img-fluid {
  width: 30px !important;
}

.video_dashboard_wrp .video_toolbar_with_prfl_img.video_toolbar_for_self .video_toolbar_list li.end_call_btn .btn {
  font-size: 16px;
}

.video_dashboard_wrp .video_toolbar_with_prfl_img.video_toolbar_for_self .video_toolbar_list li.end_call_btn {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 115px;
  flex: 0 0 135px;
  max-width: 135px;
}

.lymphomap_auth .login_form_inner .form-control[aria-invalid="true"]+.email_mbl_error {
  display: block !important;
}

.show_login_user_label_wrp.no_active {
  opacity: 0.5;
}

.sidebar_collapsed .admin_details_wrp .table .member_user_name,
.sidebar_collapsed .admin_details_wrp .table tbody td,
.sidebar_collapsed .admin_details_wrp .table thead th {
  font-size: 21px !important;
}

.sidebar_collapsed .admin_details_wrp .table thead th.member_name {
  width: 26% !important;
}

.sidebar_collapsed .admin_details_wrp .table thead th.member_city {
  width: 12% !important;
}

.sidebar_collapsed .main_dashboard .user_info_name {
  font-size: 24px !important;
}

.sidebar_collapsed .main_dashboard .main_dashboard_updates h3 {
  font-size: 24px !important;
}

.sidebar_collapsed .main_dashboard .updates_list li {
  font-size: 16px !important;
}

.sidebar_collapsed .admin_details_wrp .user_event_info .btn-primary,
.sidebar_collapsed .admin_details_wrp .badge {
  font-size: 17px !important;
}

.sidebar_collapsed .member_list_filters_wrp .count_number {
  font-size: 22px !important;
}

body.registration_form .oncology_well_form .sign_up_btn {
  display: none !important;
}

body.registration_form .oncology_well_form .more_info_add_btn,
.registration_form .lymphomap_ab_btn.showing,
.registration_form .lymphomap_computer_btn.showing,
.registration_form .cancer_classification_btn {
  display: none !important;
}

.acknowledgement_popup_show {
  overflow-y: hidden;
}

.registration_form {
  overflow-y: hidden;
  padding-right: 17px;
}

.presentation_view {
  overflow-y: hidden;
}

.presentation_view header {
  display: none !important;
}

.presentation_view footer {
  display: none !important;
}

.presentation_view .ab_main_popup {
  display: none !important;
}

body.user_agreement_popup {
  overflow-y: hidden;
}

.user_filter_label {
  letter-spacing: 0px;
}

.user_filter_label .dropdown .form_control {
  padding: 0px 25px 0px 5px !important;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1) !important;
  background-image: url("../assets/images/down_arrow.png");
  background-position: center right 4px;
  background-repeat: no-repeat;
  background-size: 12px;
  transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
  min-width: 121px;
  border-radius: 4px;
  font-size: 16px;
  color: #fff;
  line-height: 36px;
  height: 36px;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
}

.user_filter_label .dropdown-menu {
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0px !important;
  border: none;
}

.user_filter_label .dropdown-menu .dropdown-menuin ul {
  margin: 0;
  padding: 0px;
}

.user_filter_label .dropdown-menu .dropdown-menuin ul li {
  padding: 3px 5px;
  cursor: pointer;
  background: none !important;
  border: none !important;
  color: #ffc107;
  font-size: 18px;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
}

.user_filter_label .dropdown-menu .dropdown-menuin ul li:hover {
  background: #2b76ff !important;
  color: #fff;
}

.height_increased.user_filter_label .dropdown .form_control {
  height: 40px;
  line-height: 40px;
}

.signup_form .height_increased.user_filter_label .dropdown .form_control {
  height: 50px;
  line-height: 50px;
  min-width: 137px;
}

.signup_form .height_increased.user_filter_label .dropdown .form_control:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.signup_form .user_filter_label .dropdown .form_control {
  font-size: 20px;
}

.multiselect .multiselect__tags {
  border: none;
  background: rgba(255, 255, 255, 0.1) !important;
  font-size: 16px;
  padding: 12px 40px 0 8px;
  min-height: 45px;
  border-radius: 4px;
}

.multiselect__input,
.multiselect__single {
  background: none !important;
  color: #fff;
  margin: 0px !important;
  padding: 0px !important;
}

.multiselect__input::-webkit-input-placeholder {
  color: #fff !important;
}

.multiselect__input::-moz-placeholder {
  color: #fff !important;
}

.multiselect .multiselect__placeholder {
  color: #fff;
  display: inline-block;
  margin-bottom: 0;
  padding-top: 0;
  min-height: 20px;
  line-height: 20px;
  vertical-align: top;
}

.multiselect .multiselect__select {
  height: 45px;
}

.user_email_wrp .second-toolbar a {
  display: none !important;
}

.user_email_wrp .fr-view table td,
.user_email_wrp .fr-view table th {
  border: none;
}

.user_email_wrp .fr-view table th {
  background: none;
}

.user_email_wrp .fr-wrapper>div:first-child {
  display: none !important;
}

body.email_sent_popup {
  overflow-y: hidden;
}

.multiselected .invalid-feedback {
  display: block;
}

.user_email_wrp .ql-container.ql-snow {
  background: #ffffff !important;
}

.unsubscribed_lable_field .invalid-feedback {
  display: block;
}

.profile_update_wrp .user_filter_label .dropdown .form_control {
  padding: 0px 25px 0px 5px !important;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1) !important;
  background-image: url("../assets/images/down_arrow.png");
  background-position: center right 4px;
  background-repeat: no-repeat;
  background-size: 12px;
  transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
  min-width: 121px;
  border-radius: 4px;
  font-size: 20px;
  color: #fff;
  line-height: 50px;
  height: 50px;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
}

.profile_update_wrp .user_filter_label .dropdown-menu .dropdown-menuin ul li {
  font-size: 20px;
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot span {
  width: 20px;
  height: 30px;
  background: none !important;
  outline: none !important;
  font-family: FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  font-size: 40px;
  line-height: 28px;
  color: #ffc107;
  border-radius: 0px;
  text-align: center;
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot span::before {
  content: "\f104";
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot:last-child span::before {
  content: "\f105";
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot.active span {
  display: none !important;
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot:hover span {
  color: #87cefa;
}

button:focus {
  outline: none !important;
}

.member_list_filters_wrp .owl-carousel {
  position: relative;
}

.member_list_filters_wrp .owl-carousel .owl-dots {
  position: absolute;
  top: 52px;
  margin: 0 !important;
  left: 0;
  right: 0;
}

.member_list_filters_wrp .owl-carousel .owl-dots .owl-dot {
  position: absolute;
  left: -21px;
  right: auto;
  z-index: 100;
}

.member_list_filters_wrp .owl-carousel .owl-dots .owl-dot:last-child {
  right: -21px;
  left: auto;
}

.user_filter_label .dropdown .dropdown-menu {
  background: rgba(40, 40, 40, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.custom_select_dropdown .form_control {
  background-image: url("../assets/images/down_arrow.png");
  background-position: center right 5px;
  background-repeat: no-repeat;
  background-size: 12px;
  background-color: rgba(40, 40, 40, 0.8);
  -webkit-appearance: none;
  appearance: none;
  -moz-appearance: none;
  padding: 0px 15px;
  outline: none;
  font-size: 20px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  border-radius: .25rem;
}

.custom_select_dropdown .dropdown-menu {
  height: 400px;
  overflow-y: auto;
  background: rgba(40, 40, 40, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.custom_select_dropdown .dropdown-menuin ul {
  margin: 0px;
}

.custom_select_dropdown .dropdown-menuin ul li {
  padding: 3px 5px;
  cursor: pointer;
  background: none !important;
  border: none !important;
  color: #ffc107;
  font-size: 18px;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
}

.custom_select_dropdown .dropdown-menuin ul li:hover,
.custom_select_dropdown .dropdown-menuin ul li.selected {
  background: #2b76ff !important;
  color: #fff;
}

.custom_select_dropdown[aria-invalid="true"]+small.invalid-feedback {
  display: block !important;
}

.custom_select_dropdown+small.invalid-feedback {
  display: none !important;
}

.about_us_list_accordion.about_accordion_active .computer_popup_list {
  display: block;
}

body.body_right_scroll_remove {
  overflow-y: hidden;
}

.create_meeting_popup .create_meeting_popup_body .vdatetime-input {
  height: auto;
  padding: 9px 15px;
  background: rgba(255, 255, 255, 0.1);
  border-color: transparent;
  font-size: 16px;
  color: #fff;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  -webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
  transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
  border-radius: 4px;
  width: 100%;
}

.create_meeting_popup .create_meeting_popup_body .mx-datepicker .mx-icon-calendar,
.create_meeting_popup .create_meeting_popup_body .mx-datepicker .mx-icon-clear {
  color: #ffffff;
}

body .mx-datepicker-main {
  background: rgba(40, 40, 40, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffc107;
}

body .mx-datepicker-main .mx-btn {
  color: #ffc107;
}

body .mx-datepicker-main .mx-table-date .today {
  color: #87cefa;
}

body .mx-datepicker-main .mx-calendar-content .cell.active,
body .mx-datepicker-main .mx-calendar-content .cell:hover {
  background: #87cefa;
  color: #333 !important;
}

body .mx-datepicker-main .mx-table-date .cell.not-current-month {
  color: #97885a;
}

.create_meeting_popup_body .multiselect__content-wrapper {
  background: rgba(40, 40, 40, 0.95);
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffc107;
}

.create_meeting_popup_body .multiselect__content-wrapper .multiselect__option--highlight,
.create_meeting_popup_body .multiselect__option--highlight:after {
  background: #87cefa;
  color: #333 !important;
}

.create_meeting_popup_body .multiselect__content-wrapper .multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}

#frame .content .messages .msg_in_file_sent .chat_in_msg_box_wrp {
  padding: 3px;
  max-width: 250px;
}

#frame .content .messages .msg_in_file_recieved .chat_in_msg_box_wrp {
  padding: 3px;
  max-width: 250px;
}

.user_email_body .multiselect .multiselect__tags {
  font-size: 20px;
  padding-left: 15px;
}

.create_webinar_popup .create_webinar_popup_body .vdatetime-input {
  height: auto;
  padding: 9px 15px;
  background: rgba(255, 255, 255, 0.1);
  border-color: transparent;
  font-size: 16px;
  color: #fff;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  -webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
  transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
  border-radius: 4px;
  width: 100%;
}

.create_webinar_popup .create_webinar_popup_body .mx-datepicker .mx-icon-calendar,
.create_webinar_popup .create_webinar_popup_body .mx-datepicker .mx-icon-clear {
  color: #ffffff;
}

.create_webinar_popup_body .multiselect__content-wrapper {
  background: rgba(40, 40, 40, 0.95);
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffc107;
}

.create_webinar_popup_body .multiselect__content-wrapper .multiselect__option--highlight,
.create_webinar_popup_body .multiselect__option--highlight:after {
  background: #87cefa;
  color: #333 !important;
}

.create_webinar_popup_body .multiselect__content-wrapper .multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}

.create_webinar_popup_body .multiselect__single {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px !important;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #41b883 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle !important;
  width: auto;
}

.multiselect .multiselect__placeholder {
  font-size: 18px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.quillWrapper .ql-snow.ql-toolbar {
    padding-top: 8px !important;
    padding-bottom: 4px !important;
    border: none !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 0 !important;
    color: #fff !important;
    font-size: 14px !important;
    margin-bottom: 2px !important;
    border-radius: .25rem !important
}

.ql-container.ql-snow {
    border: none !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 0 !important;
    color: #fff !important;
    font-size: 14px !important;
    border-radius: .25rem !important
}

.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
    fill: #fff !important
}

.quillWrapper .ql-snow .ql-stroke,
.ql-snow .ql-toolbar button svg,
.quillWrapper .ql-snow.ql-toolbar button svg {
    stroke: #fff !important
}

.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter {
    color: #fff !important
}

.ql-snow .ql-picker-options .ql-picker-item {
    outline: none !important
}

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label {
    color: #fff !important;
    outline: none !important
}


.quillWrapper .ql-snow.ql-toolbar span.ql-formats:first-child {
    display: none !important
}

.quiz_option_content *,
.quiz_que_content * {
    margin: 0 !important;
    color: inherit;
    outline: none
}

.speaker_bio_details p,
.bio_more_data_popup_body p {
  font-size: 18px;
  line-height: 1.3;
  color: #d6d6d6;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
  margin-bottom: 15px;
  text-align: justify;
}

.editor_bio_text p:last-child {
  margin-bottom: 0;
}

#frame .content .messages li .chat_in_msg_box_wrp:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
}

#frame .content .messages li .recieved .chat_in_msg_box_wrp:after {
  border-width: 0px 0 8px 6px;
  border-color: transparent transparent transparent #ffe7eb;
  top: 0;
  right: -5px;
}

#frame .content .messages li .sent .chat_in_msg_box_wrp:after {
  border-width: 0px 6px 8px 0;
  border-color: transparent #e7f6fd transparent transparent;
  top: 0;
  left: -5px;
}

.list_msg_of_chat .messages {
  flex: 0 0 100%;
  float: none;
}

.live_msg .chat_in_msg_box_wrp {
  display: inline-block;
  padding: 5px 10px;
  line-height: 130%;
  margin: 0;
  max-width: calc(100% - 35px);
  word-break: break-word;
  white-space: normal;
  width: auto;
  position: relative;
  font-weight: 500;
}

.live_msg .chat_in_msg_box_wrp:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
}

.live_msg .recieved .chat_in_msg_box_wrp:after {
  border-width: 0px 0 8px 6px;
  border-color: transparent transparent transparent #ffb6c1;
  top: 0;
  right: -5px;
}

.live_msg .sent .chat_in_msg_box_wrp:after {
  border-width: 0px 6px 8px 0;
  border-color: transparent #b1d4e5 transparent transparent;
  top: 0;
  left: -5px;
}

.live_msg {
  padding: 5px 0px;
}

.msg_in_file_recieved .msg_link {
  display: block;
  clear: both;
  margin-top: 5px;
}

.workspace_main_page_wrp #frame #sidepanel #contacts_list .user_search_list_for_chat ul li.contact .wrap {
  padding-right: 95px;
}

.blog_content p {
  margin-bottom: 0px;
  font-size: 16px;
  font-family: 'georgiaregular';
  text-align: left;
}

.blog_content p:last-child {
  margin-bottom: 0px;
}

.blog_content {
  font-family: 'georgiaregular';
  font-size: 16px;
  letter-spacing: 0.72px;
  line-height: 1.3;
  color: #d6d6d6;
}

.blog_content * {
  font-size: 16px;
  font-family: 'georgiaregular';
  letter-spacing: 0.72px;
  line-height: 1.3;
  margin-bottom: 0;
}

.single_post_content {
  font-size: 20px;
  color: #d4d0ca;
  font-family: 'georgiaregular';
  letter-spacing: 0.72px;
  line-height: 1.58;
}

.single_post_content * {
  font-size: 20px;
  letter-spacing: 0.72px;
  line-height: 1.58;
  font-weight: normal;
  margin-bottom: 0;
  color: #d4d0ca !important;
}

.single_post_content a {
  color: #87cefa !important;
}

.single_post_content p {
  color: #d4d0ca;
  font-family: 'georgiaregular';
  margin-bottom: 0px;
  text-align: left;
  overflow-wrap: break-word;
}

.single_post_content p * {
  color: #d4d0ca !important;
}

.single_post_content p a {
  color: #87cefa !important;
}

.single_post_content p img {
  max-width: 100%;
}

.update_blogs_form_inner .custom_select_dropdown .form_control,
.create_blogs_form_inner .custom_select_dropdown .form_control {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}

.single_post_socail_share ul li span {
  cursor: pointer;
}

.create_blogs_form_inner .invalid-feedback,
.update_blogs_form_inner .invalid-feedback {
  font-size: 14px;
}

.single_post_content ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.single_post_socail_share ul li svg {
  width: 30px;
  height: 30px;
}

.blog_detail_right_section .blog_content * {
  line-height: 1.3;
  font-size: 18px;
}

.workspace_main_page_wrp .sidebar_collapsed_btn_wrp {
  display: none !important;
}

.disabled_btn_global {
  cursor: not-allowed !important;
}

.normal_user_support_chat_popup .msg_time {
  color: #c0c0c0;
}

.support_chat_reply_page_wrp #frame .content .messages li .chat_in_msg_box_wrp:after {
  display: none;
}

.support_chat_reply_page_wrp .msg_time {
  color: #c0c0c0;
}

.opacity-0,
.opacity_0 {
  opacity: 0 !important;
}

.video_conference_page .dashboard_left_sidebar_main_wrp {
  display: none !important;
}

.global_filter_name_in_html p {
  margin: 0px !important;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.1;
}

.member_list_filters_wrp .global_filter_name_in_html p:nth-child(3) {
  margin-bottom: -10px !important;
}

.drag_item_box {
  display: contents;
}

.single_post_content p.ql-align-center {
  text-align: center;
}

.single_post_content p.ql-align-center img {
  margin: 5px 0;
}

.message_sender_name {
  display: block;
  margin-top: -1px;
  font-size: 14px;
  color: #7e009a;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.create_group_team_popup_wrp .multiselect__content-wrapper {
  background: rgba(40, 40, 40, 0.95);
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffc107;
}

.create_group_team_popup_wrp .multiselect__content-wrapper .multiselect__option--highlight,
.create_group_team_popup_wrp .multiselect__option--highlight:after {
  background: #87cefa;
  color: #333 !important;
}

.create_group_team_popup_wrp .multiselect__content-wrapper .multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}

.left_sidebaar_disabled_for_page .dashboard_wrp {
  padding-left: 10px !important;
  padding-top: 0px !important;
}

.left_sidebaar_disabled_for_page .dashboard_left_sidebar_main_wrp {
  display: none !important;
}

.left_sidebaar_disabled_for_page .wrapper {
  background: #000 !important;
}

.left_sidebaar_disabled_for_page.contact_us_page_wrp .wrapper {
  background: url("../assets/images/contact_us.jpg") no-repeat #000 !important;
  background-size: cover !important;
  background-attachment: fixed !important;
}

.msg_in_file .msg_file_render_in_chat a {
  color: #000000 !important;
  text-decoration: none;
  display: flex;
  text-align: left;
  align-items: center;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 3px;
}

.msg_in_file .msg_file_render_in_chat .img-fluid {
  width: 40px;
}

.msg_in_file .msg_file_render_in_chat .msg_file_name {
  line-height: 1.4;
  display: inline-block;
  padding-left: 3px;
  font-size: 13px;
  font-weight: 500;
}

.msg_img_render_in_chat {
  height: 210px;
  min-width: 210px;
  display: block;
  margin: 0 auto;
  max-width: 210px;
}

.msg_img_render_in_chat .img-fluid {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  border-radius: 3px;
}

.msg_in_file_recieved .message_sender_name,
#live_msg_in_file_recieved .message_sender_name {
  padding: 3px 6px 0;
}

#live_msg_in_file_recieved .chat_in_msg_box_wrp {
  padding: 3px !important;
  max-width: 250px;
}

.multiselect_dropdown_ui .multiselect__content-wrapper {
  background: rgba(40, 40, 40, 0.95);
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffc107;
}

.multiselect_dropdown_ui .multiselect__content-wrapper .multiselect__option--highlight,
.multiselect_dropdown_ui .multiselect__option--highlight:after {
  background: #87cefa;
  color: #333 !important;
}

.multiselect_dropdown_ui .multiselect__content-wrapper .multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}

.bio_text_read_more {
  padding-left: 10px;
  padding-right: 10px;
}

.bio_text_read_more .editor_bio_text * {
  color: #d6d6d6 !important;
}

.bio_text_read_more .editor_bio_text ul {
  list-style-type: disc;
  padding-inline-start: 20px;
}

.bio_more_data_popup .bio_more_data_popup_modal {
  max-height: 90vh;
  overflow-y: auto;
}

.bio_more_data_popup .bio_more_data_popup_modal::-webkit-scrollbar {
  width: 5px;
  background: #000000;
}

.bio_more_data_popup .bio_more_data_popup_modal::-webkit-scrollbar-thumb {
  background-color: #232323;
  border-radius: 10px;
}

.bio_more_data_popup .bio_more_data_popup_body * {
  color: #fff !important;
  font-size: 18px;
}

.bio_more_data_popup .bio_more_data_popup_body ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.notes_converted_pdf_preview_body .header_fix {
  z-index: 99;
}

.create_data_popup .user_acknowledgement_popup .modal-backdrop {
  opacity: 0 !important;
}

.msg_time_wrp {
  display: block;
  text-align: right;
  text-transform: uppercase;
  margin-top: 2px;
  line-height: 1;
  font-size: 10px;
}

.msg_time_wrp .msg_time {
  font-size: 10px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;
  display: inline-block;
  vertical-align: middle;
}

.chat_msg_send_received_action_wrp {
  margin: 0 0 0 3px;
  display: inline-block;
  vertical-align: middle;
  line-height: 8px;
}

.chat_msg_send_received_action_wrp .msg_indication {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 50%;
  vertical-align: middle;
}

.chat_msg_send_received_action_wrp .msg_indication.msg_read_ind {
  background: #358815;
  border-color: #2a7d1a;
}

.chat_msg_send_received_action_wrp .msg_indication.msg_unsent_ind {
  border-color: #616f67;
}

.chat_msg_send_received_action_wrp .msg_indication.msg_sent_ind {
  background: #0F6281;
  border-color: #0F6281;
}

.chat_msg_send_received_action_wrp .msg_indication.froce_read {
  background: #358815 !important;
  border-color: #2a7d1a !important;
}

.chat_msg_send_received_action_wrp .fa {
  font-size: 12px;
  line-height: 1;
}

.chat_msg_send_received_action_wrp .fa.fa-flag-checkered {
  color: #2c5770;
}

.chat_msg_send_received_action_wrp .fa.fa-flag {
  color: #05cc47;
}

.chat_msg_send_received_action_wrp .fa.fa-flag-o {
  color: #616f67;
}

.list_msg_of_chat .sent .chat_msg_send_received_action_wrp {
  display: none;
}

.update_about_of_user_prfl_popup .multiselect .multiselect__tags {
  padding: 10px 40px 0 15px;
  min-height: 40px;
}

.update_about_of_user_prfl_popup .multiselect .multiselect__select {
  height: 40px;
  display: none !important;
}

.chat_in_msg_box_wrp .msg_link_chat {
  padding-right: 15px;
}

.chat_in_msg_box_wrp .msg_link {
  padding-right: 15px;
}

.chat_in_msg_box_wrp .dropdown {
  position: absolute;
  right: 5px;
  top: 5px;
  display: none;
}

.chat_in_msg_box_wrp .dropdown .msg_toggle_option {
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  line-height: 1;
  display: block;
  padding: 0 1px;
}

.chat_in_msg_box_wrp .dropdown .dropdown-menu {
  padding: 5px 0px;
  margin: 0px;
  background-color: rgba(0, 0, 0, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.chat_in_msg_box_wrp .dropdown .dropdown-menu li {
  margin: 0px !important;
  padding: 5px 10px;
  color: #ffffff;
  font-size: 15px !important;
  line-height: 1.3;
  cursor: pointer;
}

.chat_in_msg_box_wrp .dropdown .dropdown-menu li:hover {
  color: #ffd400;
}

.chat_in_msg_box_wrp .dropdown.show {
  display: block;
}

.chat_in_msg_box_wrp:hover .dropdown {
  display: block;
}

.chat_in_msg_box_wrp .message_sender_name {
  padding-right: 15px;
}

.chat_in_msg_box_wrp.delete_msg_show_box {
  padding: 5px 8px !important;
  font-size: 15px;
}

.chat_in_msg_box_wrp.delete_msg_show_box .msg_link_chat {
  padding-right: 0px !important;
  color: #4c4c4c !important;
}

.chat_in_msg_box_wrp.delete_msg_show_box .message_sender_name {
  padding-right: 0px;
}

.chat_in_msg_box_wrp.delete_msg_show_box .msg_link {
  padding-right: 0px;
  color: #4c4c4c !important;
}

.group_msg_list_box_wrp .chat_in_msg_box_wrp .dropdown {
  top: 2px;
}

#frame .content .messages .delete_msg_show_box .msg_in_file,
#frame .content .messages #live_msg_in_file_recieved .delete_msg_show_box.msg_link {
  padding: 0 5px;
}

.reply_msg_detail_view_wrp .message_sender_name {
  color: #87cefa;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 1;
}

.reply_msg_detail_view_wrp .chat_msg_content_show {
  color: #9c9c9c;
}

.delete_msg_show_box .chat_msg_content_show {
  color: #4c4c4c;
}

.sent .show_msg_of_reply_wrp {
  background: rgba(159, 179, 189, 0.55) !important;
  border-left: 3px solid rgba(255, 182, 193, 0.62);
}

.live_msg .show_msg_of_reply_wrp {
  background: #ffd9de;
  padding: 3px 8px;
  border-radius: 5px;
  border-left: 3px solid #87cefa;
  display: block;
  margin: 0px -5px 3px;
  font-weight: normal;
}

.live_msg .show_msg_of_reply_wrp .show_msg_of_reply_name {
  display: block;
  color: #565656;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 2px;
  line-height: 1;
}

.live_msg .show_msg_of_reply_wrp .show_msg_of_reply_txt {
  color: #6f6f6f;
  font-size: 13px;
}

.message_box_of_chat_wrp {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
}

.message_box_of_chat_wrp .list_msg_of_chat {
  width: 100%;
  float: left;
}

.forwarded_msg_text {
  display: block;
  text-align: left;
}

.forwarded_msg_text>span {
  display: inline-block;
  vertical-align: middle;
  margin-left: 3px;
  font-weight: normal;
  font-style: italic;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  font-family: arial;
}

.forwarded_msg_text .fa {
  color: rgba(0, 0, 0, 0.5);
  font-size: 14px;
  display: inline-block;
  vertical-align: middle;
}

@media screen and (max-width: 1280px) and (max-height: 580px) {

  .create_blogs_form_inner .custom_select_dropdown .dropdown-menu,
  .update_blogs_form_inner .custom_select_dropdown .dropdown-menu {
    height: 300px;
  }
}

.reply_msg_txt .chat_msg_content_show,
.reply_msg_txt .show_msg_of_reply_txt a {
     color: #fff;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
}

.live_msg .show_msg_of_reply_wrp .show_msg_of_reply_txt a {
  color: #6f6f6f;
  text-decoration: none;
}

.note_for_textarea_styling {
  .readonly_html_note_text {
    font-size: 18px;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
    letter-spacing: 1px;
    font-weight: 600;
    color: #000000;
    height: calc(100dvh - 278px);
    overflow-y: auto;
    padding-top: 5px;

    * {
      color: #000000;
      margin: 0px;
    }

    &::-webkit-scrollbar {
      width: 5px;
      background: none;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0.18);
    }
  }

  // .ql-toolbar{display:none !important;}
  .ql-editor {
    padding: 10px 0px;
    font-size: 18px;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
    letter-spacing: 1px;
    font-weight: 400;
    height: calc(100dvh - 278px);

    &::-webkit-scrollbar {
      width: 5px;
      background: none;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0.18);
    }

    strong {
      font-weight: 600;
    }
  }

  .quillWrapper .ql-container.ql-snow {
    background: none !important;
    color: #000000 !important;
  }
}

.notes_list_items li span.note_html_title {
  * {
    margin: 0px !important;
  }
}

.ql-editor.ql-blank::before {
  font-style: normal !important;
  left: 0 !important;
  color: rgba(0, 0, 0, 0.3) !important;
}

.vdatetime-overlay {
  background: rgba(0, 0, 0, .92) !important;
}

.vdatetime-input-styling-changed {
  .vdatetime-input {
    height: auto;
    padding: 9px 15px;
    background: rgba(255, 255, 255, 0.1);
    border-color: transparent;
    font-size: 20px;
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    -webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
    transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
    border-radius: 4px;
    width: 100%;
  }
}

.notes_view_content {
  * {
    margin: 0px !important;
  }
}

.notes_view_body_wrp.note_for_textarea_styling .ql-editor {
  height: calc(100dvh - 145px);
  font-size: 22px;
}

vdatetime-popup {
  box-shadow: 0 1px 3px 0 rgba(137, 135, 135, 0.3) !important;
  color: #ffffff !important;
  background: #000000 !important;

  .vdatetime-popup__header {
    background: #87cefa;
    color: #000000;
  }

  .vdatetime-calendar__month__day--selected>span>span,
  .vdatetime-calendar__month__day--selected:hover>span>span,
  .vdatetime-calendar__month__day:hover>span>span {
    color: #000;
    background: #87cefa;
  }

  .vdatetime-popup__actions__button {
    color: #87cefa;

    &:hover {
      color: #ffffff;
    }
  }

  .vdatetime-time-picker__item--selected {
    color: #87cefa;
  }

  .vdatetime-time-picker__with-suffix .vdatetime-time-picker__list.vdatetime-time-picker__list--suffix {
    overflow-y: hidden;
  }
}

.msg_link span,
.msg_link_chat span {
  color: #5300bf;
  text-transform: capitalize;
}

.left_sidebaar_disabled_for_page.public_page_for_wrp_img .wrapper {
  background: url("../assets/images/lymphomap-landing.jpg") no-repeat #000 !important;
  background-size: cover !important;
  background-attachment: fixed !important;
}

.model_details_val {
  * {
    margin: 0px 0px 3px !important;
  }

  br {
    display: none !important;
  }
}

.live_msg {
  .sent {
    animation: zoom-in-zoom-out 0.5s ease-out;
    -webkit-animation: zoom-in-zoom-out 0.5s ease-out;
    -moz-animation: zoom-in-zoom-out 0.5s ease-out;
    transform-origin: left bottom;
    -webkit-transform-origin: left;
    -moz-transform-origin: left bottom;
  }

  .recieved {
    animation: zoom-in-zoom-out 0.5s ease-out;
    -webkit-animation: zoom-in-zoom-out 0.5s ease-out;
    -moz-animation: zoom-in-zoom-out 0.5s ease-out;
    transform-origin: right bottom;
    -webkit-transform-origin: right bottom;
    -moz-transform-origin: right bottom;
  }
}

@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
  }

  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
  }
}

.vdatetime-popup {
  box-shadow: 0 1px 3px 0 rgba(137, 135, 135, 0.3) !important;
  color: #ffffff !important;
  background: #000000 !important;

  .vdatetime-popup__header {
    background: #87cefa;
    color: #000000;
  }

  .vdatetime-calendar__month__day--selected>span>span,
  .vdatetime-calendar__month__day--selected:hover>span>span,
  .vdatetime-calendar__month__day:hover>span>span {
    color: #000;
    background: #87cefa;
  }

  .vdatetime-popup__actions__button {
    color: #87cefa;

    &:hover {
      color: #ffffff;
    }
  }

  .vdatetime-time-picker__item--selected {
    color: #87cefa;
  }

  .vdatetime-time-picker__with-suffix .vdatetime-time-picker__list.vdatetime-time-picker__list--suffix {
    overflow-y: hidden;
  }
}

.vdatetime-input {
  height: auto;
  padding: 9px 15px;
  background: rgba(255, 255, 255, 0.1);
  border-color: transparent;
  font-size: 16px;
  color: #fff;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  -webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
  transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
  border-radius: 4px;
  width: 100%;
}

.support_chat_list_wrp {
  .chat-history {
    .recieved_list {
      text-align: right;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0px;
      }

      p {
        color: #000;
        padding: 5px 10px;
        line-height: 26px;
        font-size: 16px;
        border-radius: 7px;
        display: inline-block;
        position: relative;
        background: #ffb6c1;
        text-align: right;
        margin: 14px 0 0;
        min-width: 35px;

        &::after {
          bottom: 100%;
          border: solid transparent;
          content: " ";
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
          border-bottom-color: #ffb6c1;
          left: auto;
          right: 8px;
          border-width: 10px;
          margin-left: -10px;
        }
      }

      .msg_time {
        display: block;
        color: #96979b;
        font-size: 12px;
        padding-right: 0;
      }
    }

    .sent_list {
      text-align: left;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0px;
      }

      p {
        color: #000;
        padding: 5px 10px;
        line-height: 26px;
        font-size: 16px;
        border-radius: 7px;
        display: inline-block;
        position: relative;
        background: #b1d4e5;
        text-align: right;
        margin: 14px 0 0;
        min-width: 35px;

        &::after {
          bottom: 100%;
          border: solid transparent;
          content: " ";
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
          border-bottom-color: #b1d4e5;
          left: 8px;
          border-width: 10px;
        }
      }

      .msg_time {
        display: block;
        color: #96979b;
        font-size: 12px;
        padding-right: 0;
      }
    }
  }
}

.pdf_view_actv .employee_list_wrp .user_filters_info_popup_main .user_filters_info_popup.active {
  overflow-y: hidden !important;
}

.profile_update_wrp {
  .custom_select_dropdown {
    .form_control {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(255, 255, 255, 0.08);
      color: #ffd400;
    }

    &.show {
      .form_control {
        border: 1px solid #ffd400;
      }
    }
  }

  .user_filter_label .dropdown {
    .form_control {
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(255, 255, 255, 0.08);
      color: #ffd400;
      padding: 0px 25px 0px 20px !important;
    }

    &.show {
      .form_control {
        border: 1px solid #ffd400;
      }
    }
  }
}

.todo_tab_content_wrp {
    .quillWrapper .ql-snow .ql-stroke, .ql-snow .ql-toolbar button svg, .quillWrapper .ql-snow.ql-toolbar button svg{
        stroke: #94a3b8 !important;
    }

    .ql-snow .ql-fill, .ql-snow .ql-stroke.ql-fill{fill: #94a3b8 !important;}

    .ql-snow.ql-toolbar .ql-picker-label{color: #94a3b8 !important;}

    .quillWrapper .ql-snow.ql-toolbar span.ql-formats:first-child {
        display: inline-block !important;
        margin: 0px !important;
    }

    .quillWrapper .ql-toolbar.ql-snow button:hover{
        background: rgba(255, 255, 255, 0.09) !important;
        svg, .ql-stroke{
            stroke: #ffffff !important;
        }
       .ql-fill{fill: #ffffff !important;}
       .ql-picker-label{color: #ffffff !important;}
    }

    .quillWrapper .ql-toolbar.ql-snow .ql-picker .ql-picker-label:hover{
        background: rgba(255, 255, 255, 0.09) !important;
        color: #ffffff !important;
        svg, .ql-stroke{
            stroke: #ffffff !important;
        }
       .ql-fill{fill: #ffffff !important;}
       .ql-picker-label{color: #ffffff !important;}
    }

    .ql-picker:not(.ql-background){top: 0px !important;}

    .ql-snow .ql-picker.ql-font {
        width: 95px;
    }


    /* Font whitelist for Quill */
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=arial]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=arial]::before {
        content: 'Arial' !important;
        font-family: Arial, sans-serif !important;
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=georgia]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=georgia]::before {
        content: 'Georgia' !important;
        font-family: Georgia, serif !important;
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=tahoma]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=tahoma]::before {
        content: 'Tahoma' !important;
        font-family: Tahoma, sans-serif !important;
    }


    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=verdana]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=verdana]::before {
        content: 'Verdana' !important;
        font-family: Verdana, sans-serif !important;
    }

    /* Apply fonts in editor content */
    .ql-font-arial {
        font-family: Arial, sans-serif;
    }

    .ql-font-georgia {
        font-family: Georgia, serif;
    }

    .ql-font-tahoma {
        font-family: Tahoma, sans-serif;
    }

    .ql-font-verdana {
        font-family: Verdana, sans-serif;
    }
}
.notes_pdf_body_wrp {
  a {
    display: inline;
    color: #0563c1;
    box-sizing: border-box;
    text-decoration: underline;
  }

  span {
    display: inline-block;
    line-height: 1.25;
  }
}

.mem_usr_about_me_info {
  p {
    font-size: 15px;
    text-align: justify;
    margin: 0px;
  }
}

.e-schedule .e-more-indicator {
  color: #ffd400 !important;
}

.pdf_annotation_section {
  min-height: 100dvh;

  #content-wrapper {
    right: 0px !important;

    .page .annotationLayer {
      opacity: 0.7;

      path[data-pdf-annotate-type="drawing"] {
        stroke: #ffca00;
      }

      rect[data-pdf-annotate-type="area"] {
        stroke: red;
        stroke-width: 2;
      }

      text {
        fill: #1900ff;
      }

      text[font-size="6.666666666666666"] {
        font-size: 11px;
      }
    }
  }

  .toolbar {
    background: none;
    border: 0;
    text-shadow: none;
    right: auto;
    box-shadow: none;
    z-index: 10000;
    top: 6px;
    left: 0;
    width: auto;
    right: 0;
    text-align: center;

    @media only screen and (max-width:767px) {
      display: none !important;
    }

    .circle,
    .text,
    .text-size .scale {
      display: inline-block;
    }

    .cursor,
    .spacer,
    .hotspot-color,
    .highlight,
    .text-color,
    .arrow,
    .rotate-ccw,
    .pen-color,
    .rotate-cw,
    .strikeout,
    .comment {
      display: none !important;
    }

    >* {
      margin-right: 10px;
      margin-top: 2px;
      vertical-align: middle;
    }

    .eraser,
    .pen,
    .rectangle {
      color: #ff8a23;
      background: none;
      border: none;
      text-shadow: none;
      font-size: 24px;
      padding: 0px;
      line-height: 1;

      &:hover {
        color: #0eff2e;
      }
    }

    button {
      background-color: #272727;
      border: 1px solid #ff8a23;
      text-shadow: 1px 1px 0 #ff8a23;
      color: #ff8a23;
      line-height: 24px;
      min-height: 24px;
      padding: 0px 3px;

      &.rectangle:after {
        width: 20px;
        height: 20px;
        top: 2px;
      }

      &.active {
        color: #0eff2e;
        text-shadow: 1px 1px 0 #0eff2e;
        border-color: #0eff2e;

        &.pen,
        &.eraser {
          text-shadow: none !important;
        }
      }

      &:hover {
        border-color: #0eff2e;
      }

    }

    button[data-tooltype="emptycircle"],
    button[data-tooltype="circle"] {
      display: none;
    }

    .scale {
      option:nth-child(3) {
        display: none !important;
      }
    }

    select {
      background: #272727;
      color: #ff8a23;
      min-width: 90px;
      padding: 3px 5px;
      border-radius: 3px;
      border: 1px solid #ff8a23;
      cursor: pointer;

      &:focus-visible {
        outline: #ff8a23;
      }
    }

    a {
      &:focus-visible {
        outline-offset: none;
        outline: none;
      }
    }

    .rotate-cw,
    .rotate-ccw {
      font-size: 20px;
      color: #ff8a23;

      &:hover {
        color: #0eff2e;
      }
    }

    .clear {
      color: #ff8a23;
      background: none;
      border: none;
      text-shadow: none;
      font-size: 28px;
      padding: 0px;
      line-height: 1;

      &:hover {
        color: #0eff2e;
      }
    }

    .hotspot-color {
      a[data-name="undefined"] {
        background: #0000FF !important;
      }
    }
  }
}

body.researchfile_body_wrp.pdf_view_actv {
  overflow-y: hidden;
}

#pdf-annotate-text-input {
  font-family: 'MyriadProRegular', 'Lato', sans-serif;

}

.es_body_content {
  p:last-child {
    margin-bottom: 0px;
  }
}

.live_msg {
  position: relative;

  .live_msg_f_label {
    margin: 0;
    position: absolute;
    top: 14px;
    left: -24px;
    display: none;

    .custom_checkbox_span {
      display: flex;
      width: 16px;
      height: 16px;
      border: 2px solid #ffc107;
      border-radius: 2px;
      line-height: 16px;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .fa {
        color: #000000;
        font-size: 0px;
      }
    }

    input[type="checkbox"]:checked+.custom_checkbox_span {
      background-color: #ffc107;
      border-color: #ffc107;

      .fa {
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
}

.message_box_of_chat.selected>div {
  border-radius: 5px;

  &.sent {
  background: rgba(177, 212, 229, 0.25)
  }

  &.recieved {
    background: rgba(255, 182, 193, 0.25);
  }
}

.live_msg.selected>div {
  border-radius: 5px;

  &.sent {
  background: rgba(177, 212, 229, 0.25)
  }

  &.recieved {
    background: rgba(255, 182, 193, 0.25);
  }
}

.e-quick-popup-wrapper .e-popup-footer {
  .e-event-details {
    font-size: 0px;
    position: relative;
    padding: 0px;
    width: 26px;
    height: 46px;
    line-height: 46px;
    margin-right: 15px !important;

    &:before {
      content: "\f040";
      font-family: 'FontAwesome';
      font-size: 24px;
      color: #ffd400;
    }

    &:hover {
      background: none;

      &:before {
        color: #87cefa;
      }
    }
  }

  .e-event-create {
    background: rgba(255, 255, 255, 0.12) !important;
    color: #ffd400 !important;
    margin-right: 15px;

    &:hover {
      background: #87cefa !important;
      color: #22292f !important;
    }
  }
}

.create_data_popup {
  .uploading-progress-bar {
    padding-bottom: 0 !important;
    max-width: 100% !important;
    padding-top: 20px;
  }
}

.model_trained_loader {
  .uploading-progress-bar {
    max-width: 100% !important;
    padding-bottom: 0 !important;
  }
}

.add_event_form_wrp {
  .uploading-progress-bar {
    max-width: 100% !important;
  }
}

/* Quiz For Editor Css */
.add_qans_form_wrp {

  .quiz_option_content *,
  .quiz_que_content * {
    margin: 0 !important;
    color: inherit;
    outline: none;
  }

  .custom_editor_for_option {
    position: relative;
  }

  .custom_editor_for_option>textarea {
    position: absolute !important;
    opacity: 0 !important;
    visibility: visible !important;
    display: block !important;
    z-index: -2;
  }

  .custom_editor_for_option .cke_toolbox .cke_toolbar:nth-child(1),
  .custom_editor_for_option .cke_toolbox .cke_toolbar:nth-child(2),
  .custom_editor_for_option .cke_toolbox .cke_toolbar:nth-child(3),
  .custom_editor_for_option .cke_toolbox .cke_toolbar:nth-child(9),
  .custom_editor_for_option .cke_toolbox .cke_toolbar:nth-child(11),
  .custom_editor_for_option .cke_toolbox .cke_toolbar:nth-child(5),
  .custom_editor_for_option .cke_toolbox .cke_toolbar:nth-child(6) {
    display: none !important;
  }

  .custom_editor_for_option .cke_toolbox .cke_toolbar_break {
    display: none !important;
  }

  .custom_editor_for_option .cke_bottom .cke_path {
    display: none;
  }

  .custom_editor_for_option .cke_bottom {
    background-color: #fff;
    border-radius: 0px 0px 4px 4px;
    padding: 0px 5px 0px 0px;
    border: none;
  }

  .custom_editor_for_option .cke_top {
    padding-top: 8px !important;
    padding-bottom: 4px !important;
    border: none !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 0 !important;
    color: #ffffff !important;
    font-size: 14px !important;
    margin-bottom: 2px !important;
    border-radius: .25rem !important;
  }

  .custom_editor_for_option .cke_top .cke_button_off {
    filter: invert(100);
    -webkit-filter: invert(100);
    background-color: transparent !important;
    border: none !important;
  }

  .custom_editor_for_option .cke_top .cke_combo {
    margin-bottom: 0px;
  }

  .custom_editor_for_option .cke_top .cke_combo_arrow {
    border-top-color: #fff
  }

  .custom_editor_for_option .cke_top .cke_combo_text,
  .custom_editor_for_option .cke_top .cke_combo_button {
    background-color: transparent !important;
    border: none !important;
    color: #fff !important;
    padding: 1px !important;
    margin: 0px !important;
  }

  .custom_editor_for_option>div {
    z-index: 2;
    border: 0px !important;
  }

  .custom_editor_for_option .cke_inner {
    background: none !important;
  }

  .custom_editor_for_option a.cke_button_off:hover,
  .custom_editor_for_option a.cke_button_off:focus,
  .custom_editor_for_option a.cke_button_off:active .cke_toolbar_start+.cke_combo_on a.cke_combo_button,
  .custom_editor_for_option .cke_toolbar_start+.cke_combo_off a.cke_combo_button:active {
    padding: 4px 6px !important;
    margin: 0 !important
  }

  .custom_editor_for_option .cke_toolbar_start+.cke_combo_off a.cke_combo_button:hover,
  .custom_editor_for_option .cke_toolbar_start+.cke_combo_off a.cke_combo_button:focus {
    padding: 1px !important;
    margin: 0 !important
  }

  .custom_editor_for_option .cke_wysiwyg_frame {
    border-radius: 4px 4px 0 0;
  }
}

@media only screen and (max-width: 1300px) {
  .navbar-brand .img-fluid {
    max-width: 240px;
  }
}

@media only screen and (max-width: 1023px) {
  .header_fix {
    background: #000 !important;
  }
}

.rsg_des {
  * {
    margin: 0px;
  }

  color:#c8c3af;
  font-size:16px;
  line-height:1.4;

  ul {
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
}

.cke_notification.cke_notification_warning {
  display: none !important;
}

.body_right_scroll_remove .some_details_of_group_wrp {
  z-index: 1111 !important;
}

#frame.acvt_toolbar .right_todo_sidebar_wrp {
  display: block !important;
}

#frame.acvt_toolbar .chat_workspace_wrp {
  display: none !important;
}

.custom_datetime_picker {
  .vpd-main {
    display: block;
    border-radius: 5px;
    padding: 0px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    outline: none !important;
    box-shadow: none !important;
    background: rgba(255, 255, 255, 0.08);
    height: 44px;
    line-height: 44px;

    .vpd-month-label {
      width: 110px !important;

      &>span {
        padding: 0px;
      }
    }

    .vpd-year-label {
      height: auto;

      &>span {
        padding: 0x;
      }
    }

    .vpd-icon-btn {
      background: none !important;
      line-height: 1;
      padding-right: 0px;

      svg {
        fill: rgba(255, 255, 255, 0.35);
      }
    }

    .vpd-input-group input {
      background: none;
      border: none;
      color: #ffd400;
    }

    .vpd-wrapper {
      position: absolute;
      font-size: 14px;

      .vpd-header {
        background: #87cefa !important;
        color: #000000;
      }

      .vpd-body {
        box-shadow: 0 1px 3px 0 rgba(137, 135, 135, .3) !important;
        color: #ffffff !important;
        background: #000000 !important;
      }
    }

    .vpd-day[disabled] .vpd-day-text {
      color: #4e4d48;
    }

    .vpd-controls button svg path {
      fill: #fff;
    }
  }

  &.active {
    .vpd-icon-btn svg {
      fill: #ffd400 !important;
    }
  }
}


.login_body {
  overflow-y: scroll;

  .header_fix {
    background: none;
    width: calc(100% - 65px);

    @media only screen and (max-width: 767px) {
      width: 100%
    }
  }

  &::-webkit-scrollbar {
    width: 5px;
    background: #000 16px
  }

  &::-moz-scrollbar {
    width: 5px;
    background: #000 16px
  }

  &::-webkit-scrollbar-thumb {
    background-color: #232323
  }

  &::-moz-scrollbar-thumb {
    background-color: #232323
  }

  &.covid_19_popup_actv .request_for_demo_section_main {
    opacity: 0 !important
  }

}

@media only screen and (max-width: 767px) {
  .login_body .footer_wrp.d-none {
    display: block !important;
  }

  .home_rdrtc_cross {
    padding: 2px 5px !important;
    font-size: 18px !important;
  }

  .mbl_table_responsive {
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      border: 1px solid rgba(228, 233, 237, 0.22);
      margin-bottom: 8px;
      border-radius: 5px;
    }

    td {
      border: none;
      border-bottom: 1px solid rgba(228, 233, 237, 0.05);
      background: rgba(228, 233, 237, 0.08);
      position: relative;
      padding: 5px 8px 5px 35% !important;
      &[colspan]{
        padding-left: 0px !important;
      }

      &:last-child {  
        border-bottom: 0;
      }

      &::before {
        content: attr(data-label);
        position: absolute;
        left: 6px;
        width: 35%;
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
        font-size: 16px;
        color: #87cefa;
      }
    }
  }
}
</style>